import type { GetTranslationAsyncStatusDTO } from '../service/ai-translation.repository.interface';
import type { GetTranslationAsyncStatusResponse } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetTranslationAsyncStatus } from '@/infrastructure/api-functions/interface/get-translation-async-status.interface';

@injectable()
export class GetTranslationAsyncStatusDTOImpl implements GetTranslationAsyncStatusDTO {
    constructor(
        @inject(GetTranslationAsyncStatus)
        private readonly _getTranslationAsyncStatusApi: GetTranslationAsyncStatus,
    ) { }

    async fetch(taskId: string): Promise<GetTranslationAsyncStatusResponse> {

        const res = await this._getTranslationAsyncStatusApi.getTranslationAsyncStatus(taskId);

        return {
            taskId: res.task_id,
            status: res.status,
            content: res.content.map(item => ({
                original: item.src_text,
                translation: item.translated_text,
                graphIndex: item.graph_index,
            })),
        }
    }
}
